module.exports = __webpack_public_path__ + "img/1x1_blur.2398a2b7.jpg";